import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=0543b5ca&scoped=true&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "../assets/js/home.css?vue&type=style&index=0&id=0543b5ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0543b5ca",
  null
  
)

export default component.exports